import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ScrollText } from 'lucide-react';
import TermsContent, { TERMS_LAST_UPDATED } from '../components/TermsContent';

/**
 * Terms & Conditions — public standalone page (`/terms`). Kept for
 * external / shared URLs. All in-app entry points open the same
 * content in a modal via `useTermsModal()` — the shared
 * `<TermsContent />` component keeps the two surfaces in sync.
 */
const Terms = () => {
  useEffect(() => {
    document.title = 'Terms & Conditions · Pray Now Together';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 space-y-6" data-testid="terms-page">
      <Link
        to="/"
        data-testid="terms-back-link"
        className="inline-flex items-center gap-2 text-sm text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-white"
      >
        <ArrowLeft size={16} /> Back
      </Link>

      <header className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full bg-amber-100 dark:bg-amber-950/50 flex items-center justify-center text-amber-600 dark:text-amber-300">
          <ScrollText size={22} />
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-semibold text-zinc-900 dark:text-white" data-testid="terms-heading">
            Terms &amp; Conditions
          </h1>
          <p className="text-xs text-zinc-500 dark:text-zinc-400 mt-0.5" data-testid="terms-last-updated">
            Last updated: {TERMS_LAST_UPDATED}
          </p>
        </div>
      </header>

      <TermsContent />

      <div className="pt-4 border-t border-zinc-200 dark:border-zinc-800 text-xs text-zinc-500 dark:text-zinc-400">
        © {new Date().getFullYear()} Pray Now Together. All rights reserved.
      </div>
    </div>
  );
};

export default Terms;
